import React from 'react'
import ReactDOM from 'react-dom'

import App from './features/App'
import { initAmplitude } from './api/analytics'

initAmplitude()
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
)
